(() => {
	const parser = new DOMParser();

	function init() {
		const scrollContainers = document.querySelectorAll('[data-infinite-scroll]');

		scrollContainers.forEach((container) => {
			if (!container.id) {
				console.error('Infinite scroll containers must have a unique ID.');
				return;
			}

			if (!container.dataset.infiniteScroll) {
				console.error('Infinite scroll containers must have a child selector.');
				return;
			}

			if (!container.dataset.currentPage || !container.dataset.totalPages) {
				console.error('Infinite scroll containers must supply current page and total pages.');
				return;
			}

			initInfiniteScroll(container);
		});
	}

	function initInfiniteScroll(container) {
		let isLoading = false;
		const spinner = document.querySelector(container.dataset.indicator);

		// Infinite scroll
		// ----------------------------------------

		window.addEventListener('scroll', loadContent, {passive: true});

		window.addEventListener('page:load-started', () => {
			window.removeEventListener('scroll', loadContent);
		});

		async function loadContent() {
			const isAtBottom = container.getBoundingClientRect().bottom <= window.innerHeight;
			const isLastPage = container.dataset.currentPage >= container.dataset.totalPages;

			if (isAtBottom && !isLoading && !isLastPage) {
				isLoading = true;

				if (spinner) spinner.classList.remove('d-none');

				let url = window.location.href;

				if (url.indexOf('?') == -1) {
					url += `?page=${parseInt(container.dataset.currentPage) + 1}`;
				} else {
					url += `&page=${parseInt(container.dataset.currentPage) + 1}`;
				}

				const data = await ajax('GET', url);
				const newDoc = parser.parseFromString(data, 'text/html');
				const newContainer = newDoc.querySelector(`#${container.id}`);
				const newEls = newContainer.querySelectorAll(container.dataset.infiniteScroll);

				container.dataset.currentPage = newContainer.dataset.currentPage;
				container.dataset.totalPages = newContainer.dataset.totalPages;

				// Add new articles
				newEls.forEach((el) => {
					el.classList.add('new');

					gsap.set(el, {
						opacity: 0,
						y: 50
					});

					container.appendChild(el);
				});

				// Update links
				initPageLinks();

				// Animate
				const els = container.querySelectorAll(`${container.dataset.infiniteScroll}.new`);

				await gsap.timeline().to(els, {
					duration: 0.3,
					stagger: 0.1,
					opacity: 1,
					y: 0
				});

				els.forEach((el) => el.classList.remove('new'));

				if (spinner) spinner.classList.add('d-none');

				isLoading = false;

				// Keep loading if the user has already scrolled to the bottom
				loadContent();
			}
		}
	}

	// Events
	// ----------------------------------------

	$DOC.ready(() => {
		init();
	});

	$WINDOW.on('page:content-updated', (e) => {
		init();
	});
})();
